import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ClientsSection from "@/components/sections/ClientsSection";
import { SITE } from "@/lib/seo";
import { CASES } from "@/data/cases";

const TITLE = "Casos de Éxito de Clientes | Vibra Marketing";
const DESCRIPTION =
  "Resultados reales: +5M€ presupuestados, +2.500 leads y 100% de retención. Casos de éxito de Vibra Marketing en e-commerce, SaaS, reformas, hostelería y más.";
const URL = `${SITE.url}/casos-de-exito`;

const breadcrumb = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Inicio", item: `${SITE.url}/` },
    { "@type": "ListItem", position: 2, name: "Casos de éxito", item: URL },
  ],
};

const itemList = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: CASES.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    url: `${SITE.url}/casos/${c.slug}`,
    name: `${c.name} — ${c.headline}`,
  })),
};

const Casos = () => (
  <div className="min-h-screen bg-background">
    <Helmet>
      <title>{TITLE}</title>
      <meta name="description" content={DESCRIPTION} />
      <link rel="canonical" href={URL} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={TITLE} />
      <meta property="og:description" content={DESCRIPTION} />
      <meta property="og:url" content={URL} />
      <meta property="og:image" content={SITE.ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      <script type="application/ld+json">{JSON.stringify(itemList)}</script>
    </Helmet>
    <Header />
    <main className="pt-16">
      <nav aria-label="Breadcrumb" className="container px-6 pt-8 text-xs text-muted-foreground">
        <ol className="flex items-center gap-2">
          <li><Link to="/" className="hover:text-foreground">Inicio</Link></li>
          <li aria-hidden>/</li>
          <li className="text-foreground">Casos de éxito</li>
        </ol>
      </nav>

      <header className="container px-6 pt-10 pb-4 text-center max-w-3xl mx-auto">
        <h1 className="font-display text-4xl md:text-6xl uppercase mb-6">
          Casos de éxito: resultados <span className="text-gradient">reales</span>
        </h1>
        <div className="flex flex-wrap justify-center gap-2 mt-4">
          {["+5M€ presupuestados", "+2.500 leads", "100% retención"].map((c) => (
            <span
              key={c}
              className="px-3 py-1.5 rounded-full border border-primary/30 bg-accent text-xs font-medium uppercase tracking-wider"
            >
              {c}
            </span>
          ))}
        </div>
      </header>

      <ClientsSection hideHeader />


      <section className="container px-6 pb-24">
        <div className="rounded-3xl bg-gradient-to-br from-primary/10 via-purple-500/5 to-background border border-primary/20 px-6 py-12 md:py-16 text-center shadow-[0_0_60px_-20px_hsl(var(--primary)/0.3)]">
          <h2 className="font-display text-3xl md:text-5xl uppercase mb-4">
            ¿Quieres ser el próximo caso?
          </h2>
          <p className="text-muted-foreground mb-8 max-w-xl mx-auto">
            Agenda una llamada gratuita y te contamos cómo podemos conseguir
            resultados parecidos para tu negocio.
          </p>
          <Link
            to="/contacto"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary text-primary-foreground font-medium hover:opacity-90 transition-opacity"
          >
            Agenda una llamada <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default Casos;
